export default "__VITE_ASSET__bw8RAY_n__"